export default "__VITE_ASSET__Dp05t7Pf__"